import { useTranslation } from "react-i18next";

import { AboutPage } from "./AboutPage";
import logo from "./logo.svg";

// import { ContentArea } from "../../components/ContentArea";
// import { ToolbarTop } from "../../components/ToolbarTop";

export default function AboutProgram() {
  const { t } = useTranslation();
  return (
    // <ContentArea>
    //   <ToolbarTop pageTitle={t("navigation.aboutProgram")}></ToolbarTop>
      <AboutPage
        title={t("loginPage.applicationName")}
        version={t("loginPage.appVersion")}
        logo={logo}
      />
    // </ContentArea>
  );
}